(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyJournalDeleteController',CurrencyJournalDeleteController);

    CurrencyJournalDeleteController.$inject = ['$uibModalInstance', 'entity', 'CurrencyJournal'];

    function CurrencyJournalDeleteController($uibModalInstance, entity, CurrencyJournal) {
        var vm = this;

        vm.currencyJournal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CurrencyJournal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
